import React from 'react';
import './ec2ExTableRow.css';
import Ec2ExTableCell from './ec2ExTableCell/ec2ExTableCell.js';
import Ec2ExRowControls from './ec2ExRowControls/ec2ExRowControls.js';

const Ec2ExTableRow = ({instance, headers, toggleHideRow, swapInstanceOrder}) => {

  const formattedInstance = () => {
    const formattedInstance = {...instance};

    headers.forEach(header => {
      delete formattedInstance[header.key];
    });

    return formattedInstance;
  };

  return (
    <tr className="Ec2ExTableRowPage">
      <Ec2ExRowControls toggleHideRow={toggleHideRow} instanceId={instance.InstanceId} swapInstanceOrder={swapInstanceOrder}/>
      {headers.slice(1).map(header => {
        return <Ec2ExTableCell key={header.title} instance={instance} header={header} formattedInstance={formattedInstance()}/>;
      })}
    </tr>
  );

};

export default Ec2ExTableRow;


// WEBPACK FOOTER //
// ./src/components/content/ec2ResExplorer/ec2ExMain/ec2ExTableRow/ec2ExTableRow.js